import React from "react";

export const ArrowLeftIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M19 12H5M12 19l-7-7 7-7"/>
  </svg>
);

export const UserPlusIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <line x1="19" y1="8" x2="19" y2="14"/>
    <line x1="22" y1="11" x2="16" y2="11"/>
  </svg>
);

export const PhoneIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
  </svg>
);

export const MailIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect width="20" height="16" x="2" y="4" rx="2"/>
    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
  </svg>
);

export const MailIconLarge = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect width="20" height="16" x="2" y="4" rx="2"/>
    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
  </svg>
);

export const MessageSquareIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
  </svg>
);

export const MapPinIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/>
    <circle cx="12" cy="10" r="3"/>
  </svg>
);

export const PulseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
  </svg>
);

export const PhoneOutlineIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
  </svg>
);

export const ChevronDownIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="m6 9 6 6 6-6"/>
  </svg>
);

export const BasicDetailsIcon = () => (
  <svg width="48" height="52" viewBox="0 0 71 76" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_2849_8082)">
      <g clipPath="url(#clip0_2849_8082)">
        <path d="M1.95312 33.1504C1.95312 15.919 15.9219 1.9502 33.1533 1.9502C50.3847 1.9502 64.3535 15.919 64.3535 33.1504C64.3535 50.3818 50.3847 64.3506 33.1533 64.3506C15.9219 64.3506 1.95312 50.3818 1.95312 33.1504Z" fill="white" fillOpacity="0.01" shapeRendering="crispEdges"/>
        <path d="M1.95312 33.1504C1.95312 15.919 15.9219 1.9502 33.1533 1.9502C50.3847 1.9502 64.3535 15.919 64.3535 33.1504C64.3535 50.3818 50.3847 64.3506 33.1533 64.3506C15.9219 64.3506 1.95312 50.3818 1.95312 33.1504Z" fill="url(#paint0_linear_2849_8082)"/>
        <path d="M42.2626 44.8518V42.2518C42.2626 40.8727 41.7148 39.55 40.7396 38.5748C39.7644 37.5996 38.4417 37.0518 37.0626 37.0518H29.2625C27.8834 37.0518 26.5607 37.5996 25.5856 38.5748C24.6104 39.55 24.0625 40.8727 24.0625 42.2518V44.8518" stroke="#0092B8" strokeWidth="2.60002" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M33.1453 31.8507C36.0172 31.8507 38.3454 29.5226 38.3454 26.6507C38.3454 23.7788 36.0172 21.4507 33.1453 21.4507C30.2734 21.4507 27.9453 23.7788 27.9453 26.6507C27.9453 29.5226 30.2734 31.8507 33.1453 31.8507Z" stroke="#0092B8" strokeWidth="2.60002" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
    </g>
    <g filter="url(#filter1_dd_2849_8082)">
      <path d="M44.8594 54.6006C44.8594 49.2158 49.2246 44.8506 54.6094 44.8506C59.9942 44.8506 64.3595 49.2158 64.3595 54.6006C64.3595 59.9855 59.9942 64.3507 54.6094 64.3507C49.2246 64.3507 44.8594 59.9855 44.8594 54.6006Z" fill="url(#paint1_linear_2849_8082)" shapeRendering="crispEdges"/>
      <g clipPath="url(#clip1_2849_8082)">
        <path d="M55.274 52.0005C55.3913 52.0005 55.5064 52.0322 55.6071 52.0923C55.7078 52.1524 55.7904 52.2386 55.8461 52.3417L56.004 52.6342C56.0597 52.7374 56.1423 52.8236 56.243 52.8837C56.3437 52.9438 56.4587 52.9755 56.576 52.9755H57.225C57.3974 52.9755 57.5628 53.044 57.6847 53.1659C57.8066 53.2878 57.875 53.4531 57.875 53.6255V56.5505C57.875 56.7229 57.8066 56.8882 57.6847 57.0101C57.5628 57.132 57.3974 57.2005 57.225 57.2005H52.025C51.8526 57.2005 51.6873 57.132 51.5654 57.0101C51.4435 56.8882 51.375 56.7229 51.375 56.5505V53.6255C51.375 53.4531 51.4435 53.2878 51.5654 53.1659C51.6873 53.044 51.8526 52.9755 52.025 52.9755H52.674C52.7912 52.9755 52.9061 52.9439 53.0068 52.8839C53.1074 52.8239 53.19 52.7379 53.2457 52.6349L53.4046 52.3411C53.4604 52.2381 53.543 52.152 53.6436 52.0921C53.7442 52.0321 53.8592 52.0005 53.9763 52.0005H55.274Z" stroke="white" strokeWidth="0.650004" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M54.6078 55.9007C55.1463 55.9007 55.5828 55.4642 55.5828 54.9257C55.5828 54.3872 55.1463 53.9507 54.6078 53.9507C54.0693 53.9507 53.6328 54.3872 53.6328 54.9257C53.6328 55.4642 54.0693 55.9007 54.6078 55.9007Z" stroke="white" strokeWidth="0.650004" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
    </g>
    <defs>
      <filter id="filter0_d_2849_8082" x="0.00311279" y="0.000183105" width="66.2985" height="66.3004" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feMorphology radius="1.95001" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_2849_8082"/>
        <feOffset/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0.636648 0 0 0 0 0.955424 0 0 0 0 0.992155 0 0 0 1 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2849_8082"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2849_8082" result="shape"/>
      </filter>
      <filter id="filter1_dd_2849_8082" x="39.0093" y="43.8756" width="31.2001" height="31.2001" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feMorphology radius="1.95001" operator="erode" in="SourceAlpha" result="effect1_dropShadow_2849_8082"/>
        <feOffset dy="1.95001"/>
        <feGaussianBlur stdDeviation="1.46251"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2849_8082"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feMorphology radius="1.46251" operator="erode" in="SourceAlpha" result="effect2_dropShadow_2849_8082"/>
        <feOffset dy="4.87503"/>
        <feGaussianBlur stdDeviation="3.65627"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
        <feBlend mode="normal" in2="effect1_dropShadow_2849_8082" result="effect2_dropShadow_2849_8082"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_2849_8082" result="shape"/>
      </filter>
      <linearGradient id="paint0_linear_2849_8082" x1="1.95312" y1="1.9502" x2="64.3535" y2="64.3506" gradientUnits="userSpaceOnUse">
        <stop stopColor="#CEFAFE"/>
        <stop offset="1" stopColor="#DBEAFE"/>
      </linearGradient>
      <linearGradient id="paint1_linear_2849_8082" x1="44.8594" y1="44.8506" x2="64.3595" y2="64.3507" gradientUnits="userSpaceOnUse">
        <stop stopColor="#00B8DB"/>
        <stop offset="1" stopColor="#2B7FFF"/>
      </linearGradient>
      <clipPath id="clip0_2849_8082">
        <path d="M1.95312 33.1504C1.95312 15.919 15.9219 1.9502 33.1533 1.9502C50.3847 1.9502 64.3535 15.919 64.3535 33.1504C64.3535 50.3818 50.3847 64.3506 33.1533 64.3506C15.9219 64.3506 1.95312 50.3818 1.95312 33.1504Z" fill="white"/>
      </clipPath>
      <clipPath id="clip1_2849_8082">
        <rect width="7.80005" height="7.80005" fill="white" transform="translate(50.7109 50.7007)"/>
      </clipPath>
    </defs>
  </svg>
);

export const AddressIcon = () => (
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 14C0 6.26801 6.26801 0 14 0H22C29.732 0 36 6.26801 36 14V22C36 29.732 29.732 36 22 36H14C6.26801 36 0 29.732 0 22V14Z" fill="url(#paint0_linear_address)"/>
    <path d="M18 9.6665C15.4227 9.6665 13.3333 11.7559 13.3333 14.3332C13.3333 17.9165 18 26.3332 18 26.3332C18 26.3332 22.6667 17.9165 22.6667 14.3332C22.6667 11.7559 20.5773 9.6665 18 9.6665Z" stroke="white" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="18" cy="14.3332" r="1.66667" stroke="white" strokeWidth="1.66667"/>
    <defs>
      <linearGradient id="paint0_linear_address" x1="0" y1="0" x2="36" y2="36" gradientUnits="userSpaceOnUse">
        <stop stopColor="#00B8DB"/>
        <stop offset="1" stopColor="#2B7FFF"/>
      </linearGradient>
    </defs>
  </svg>
);

export const ContactInfoIcon = () => (
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 14C0 6.26801 6.26801 0 14 0H22C29.732 0 36 6.26801 36 14V22C36 29.732 29.732 36 22 36H14C6.26801 36 0 29.732 0 22V14Z" fill="url(#paint0_linear_contact)"/>
    <path d="M19.5241 21.8065C19.6962 21.8855 19.8901 21.9036 20.0738 21.8577C20.2575 21.8118 20.4202 21.7047 20.5349 21.554L20.8307 21.1665C20.986 20.9595 21.1873 20.7915 21.4187 20.6758C21.6501 20.5601 21.9053 20.4998 22.1641 20.4998H24.6641C25.1061 20.4998 25.53 20.6754 25.8426 20.988C26.1551 21.3006 26.3307 21.7245 26.3307 22.1665V24.6665C26.3307 25.1085 26.1551 25.5325 25.8426 25.845C25.53 26.1576 25.1061 26.3332 24.6641 26.3332C20.6858 26.3332 16.8705 24.7528 14.0575 21.9398C11.2444 19.1267 9.66406 15.3114 9.66406 11.3332C9.66406 10.8911 9.83966 10.4672 10.1522 10.1547C10.4648 9.8421 10.8887 9.6665 11.3307 9.6665H13.8307C14.2728 9.6665 14.6967 9.8421 15.0092 10.1547C15.3218 10.4672 15.4974 10.8911 15.4974 11.3332V13.8332C15.4974 14.0919 15.4372 14.3471 15.3214 14.5785C15.2057 14.81 15.0377 15.0113 14.8307 15.1665L14.4407 15.459C14.2877 15.5758 14.1799 15.742 14.1356 15.9293C14.0912 16.1166 14.113 16.3135 14.1974 16.4865C15.3363 18.7997 17.2094 20.6705 19.5241 21.8065Z" stroke="white" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
    <defs>
      <linearGradient id="paint0_linear_contact" x1="0" y1="0" x2="36" y2="36" gradientUnits="userSpaceOnUse">
        <stop stopColor="#00B8DB"/>
        <stop offset="1" stopColor="#2B7FFF"/>
      </linearGradient>
    </defs>
  </svg>
);

// Sidebar Icons
export const SearchIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="8"/>
    <path d="m21 21-4.3-4.3"/>
  </svg>
);

export const GridIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect width="7" height="7" x="3" y="3" rx="1"/>
    <rect width="7" height="7" x="14" y="3" rx="1"/>
    <rect width="7" height="7" x="14" y="14" rx="1"/>
    <rect width="7" height="7" x="3" y="14" rx="1"/>
  </svg>
);

export const MenuIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="4" x2="20" y1="6" y2="6"/>
    <line x1="4" x2="20" y1="12" y2="12"/>
    <line x1="4" x2="20" y1="18" y2="18"/>
  </svg>
);

export const AnalyticsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
  </svg>
);

export const CalendarIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect width="18" height="18" x="3" y="4" rx="2" ry="2"/>
    <line x1="16" x2="16" y1="2" y2="6"/>
    <line x1="8" x2="8" y1="2" y2="6"/>
    <line x1="3" x2="21" y1="10" y2="10"/>
  </svg>
);

export const UsersIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M22 21v-2a4 4 0 0 0-3-3.87"/>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
  </svg>
);

export const StethoscopeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4.8 2.3A.3.3 0 1 0 5 2H4a2 2 0 0 0-2 2v5a6 6 0 0 0 6 6v0a6 6 0 0 0 6-6V4a2 2 0 0 0-2-2h-1a.2.2 0 1 0 .3.3"/>
    <path d="M8 15v1a6 6 0 0 0 6 6v0a6 6 0 0 0 6-6v-4"/>
    <circle cx="20" cy="10" r="2"/>
  </svg>
);

export const LinkIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
  </svg>
);

export const PlusIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 12h14"/>
    <path d="M12 5v14"/>
  </svg>
);

export const SparklesIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"/>
    <path d="M5 3v4"/>
    <path d="M19 17v4"/>
    <path d="M3 5h4"/>
    <path d="M17 19h4"/>
  </svg>
);

export const SettingsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"/>
    <circle cx="12" cy="12" r="3"/>
  </svg>
);

export const HamburgerIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="4" x2="20" y1="12" y2="12"/>
    <line x1="4" x2="20" y1="6" y2="6"/>
    <line x1="4" x2="20" y1="18" y2="18"/>
  </svg>
);

export const CloseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 6 6 18"/>
    <path d="m6 6 12 12"/>
  </svg>
);

export const CapsuleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="m10.5 20.5 10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7Z"/>
    <path d="m8.5 8.5 7 7"/>
  </svg>
);

export const VaccineShieldIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
    <path d="m9 12 2 2 4-4"/>
  </svg>
);

export const PanelLeftIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect width="18" height="18" x="3" y="3" rx="2"/>
    <path d="M9 3v18"/>
  </svg>
);

export const KaagazyLogoIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M22 21v-2a4 4 0 0 0-3-3.87"/>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
  </svg>
);

export const ReceiptIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z"/>
    <path d="M14 8H8"/>
    <path d="M16 12H8"/>
    <path d="M13 16H8"/>
  </svg>
);

export const CircleDollarSignIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <path d="M16 8h-6a2 2 0 0 0 0 4h4a2 2 0 0 1 0 4H8"/>
    <path d="M12 18V6"/>
  </svg>
);

export const ShieldCheckIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/>
    <path d="m9 12 2 2 4-4"/>
  </svg>
);

export const TrashIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 6h18"/>
    <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/>
    <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/>
  </svg>
);

export const CheckIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 6 9 17l-5-5"/>
  </svg>
);

export const PackageIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="m7.5 4.27 9 5.15"/>
    <path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"/>
    <path d="m3.3 7 8.7 5 8.7-5"/>
    <path d="M12 22V12"/>
  </svg>
);
